/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  InputProtocolTypes,
  InputType,
  MessageType,
  MouseButtons,
  TimeoutType,
  WebSocketTimeoutError,
} from '@acs-manageability/core'

import { onAnswer, onAddIceCandidate, onOffer } from '@acs-manageability/webrtc-react'
import { emit } from './EventUtils'

const INITIATE_MESSAGE = {
  version: 1,
  components: {
    audio: {
      version: 1,
      supported_streams: [],
    },
    video: {
      version: 1,
      supported_streams: [
        {
          version: 1,
          codec: 'H264',
          chroma: '420',
          depth: '8',
          lossless: false,
          options: {},
        },
      ],
    },
    input: {
      version: 1,
      protocol_version: 1,
      protocol_format: InputProtocolTypes.JSON,
      keyboard: {
        version: 1,
        lang: null,
        layout: null,
        supported_input: [InputType.ASCII],
      },
      mouse: {
        version: 1,
        supported_buttons: [
          MouseButtons.LButton,
          MouseButtons.MButton,
          MouseButtons.RButton,
          MouseButtons.XButton1,
          MouseButtons.XButton2,
        ],
        supports_absolute: true,
        supports_relative: true,
        supports_horizontal_wheel: false,
        supports_invert_wheel: false,
        supports_wheel: true,
      },
    },
    hostname: window.location.hostname,
  },
}

export default ({ webSocketConnection, promiseResolver, broker }) => {
  const connect = (hostname, deviceId, token, reloadDevice) => {
    return new Promise((resolve, reject) => {
      const url = `${hostname}?from=client&session_token=${token}&target_device_id=${deviceId}`
      try {
        emit('kvm_status_changed', { step: 'connection_to_signal' })
        webSocketConnection.connect(url, token)

        webSocketConnection.onopen(async () => {
          emit('reset_timeout_check_task', {})
          emit('kvm_status_changed', { step: 'allocate_remote_device' })
          const brokerMessage = broker.getMessage(MessageType.HELLO)
          const message = {
            message_type: MessageType.HELLO,
            content: brokerMessage,
          }
          webSocketConnection.sendMessage(message)
        })

        webSocketConnection.onerror(async () => {
          emit('kvm_status_changed', { error: 'signal_error' })
          reject(new Error('Failed to connect'))
        })

        webSocketConnection.setMessageHandler({
          onHelloRespMessage: (content) => {
            resolve()
          },
          onAuthenticateRespMessage: (content) => {
            promiseResolver.promiseResolve()
          },
          onTurnAuthenticationRespMessage: (content) => {
            const iceServers = broker.getMessageInfo(content, MessageType.GET_TURN_CREDENTIALS_RESP)
            promiseResolver.promiseResolve(iceServers)
          },
          onGetResourcesListRespMessage: (content) => {
            const resourceList = broker.getMessageInfo(content, MessageType.GET_RESOURCES_LIST)
            promiseResolver.promiseResolve(resourceList)
          },
          onResendAllocateMessage: () => {
            if (reloadDevice) {
              reloadDevice()
            }
          },
          onAllocateRespMessage: (content) => {
            const initiateMessage = {
              message_type: MessageType.INITIATE,
              content: INITIATE_MESSAGE,
            }
            webSocketConnection.sendMessage(initiateMessage)
            promiseResolver.promiseResolve(undefined)
          },
          onError: (content) => {
            const error = broker.getResultError(content)
            promiseResolver.promiseReject(error)
          },
          onClose: (content) => {
            const error = { name: 'ON_CLOSE_ERROR', message: content }

            //TODO: review reject(error.message);
          },
          onAddIceCandidate,
          onOffer,
          onAnswer,
        })
      } catch (e) {
        reject(e)
      }
    })
  }

  const disconnectFromServer = () => {
    webSocketConnection.sendMessage({ close: true })
  }

  return {
    connect,
    disconnectFromServer,
  }
}
